export default class {
    scrollLinks = document.querySelectorAll('.js_scroll');
    headerHeight = document.querySelector('.js_navbar').offsetHeight;

    constructor() {
        this.listen();
    }

    listen() {
        this.scrollLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault()

                if (link.closest('.mobile-menu')) {
                    if (document.querySelector('.js_header-top').classList.contains('header__top--fix')) {
                        this.headerHeight = document.querySelector('.js_header-top').offsetHeight;
                    } else {
                        this.headerHeight = (document.querySelector('.js_header-top').offsetHeight) * 2;
                    }
                    
                    setTimeout(() => {
                        document.body.classList.remove('ovhidden');
                        document.querySelector('.header').classList.remove('open-menu');
                        document.querySelector('.js_toggle-mobile-menu').classList.remove('open');
                    }, 15);
                }

                const elementToScroll = document.querySelector(link.getAttribute("href"));
                let scrollTop = elementToScroll.getBoundingClientRect().top + window.scrollY - this.headerHeight;

                window.scrollTo({
                    top: scrollTop,
                    behavior: "smooth"
                });
            })
        })
    }
}
